import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import TitleBar from '../components/TitleBar';
import ContactUsForm from '../components/ContactUsForm';

export default class Feeback extends React.Component {
  render() {
    return (
      <div id="feedback">
        <TitleBar title="Provide Feedback" backlink="/home" />
        <div id="contactForm" className="section">
          <Container>
            {/* <Row>
              <Col lg={12} md={5} sm={12} xs={12}>
               
              </Col>
            </Row> */}
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className={'no-padding'}
              >
                <h1
                  style={{
                    marginTop: '10px',
                    color: 'black',
                    textAlign: 'center',
                  }}
                >
                  Thank you for your support!
                </h1>
                <p>
                  We are so excited to be launching Trevel in our
                  hometowns of Kansas City and St. Louis!
                </p>
                <p>
                  While we hope you have a seemless experience
                  exploring our app and exploring your city, there may
                  be bumps along the way as we get started.
                </p>

                <p>
                  Please help us improve by shareing any issues you
                  find along the way, and by providing any feedback
                  you have to help us make a better exprience for
                  everyone. <b>Thank you!</b>
                </p>
                <span style={{ fontWeigt: '800' }}>
                  - Mike and Mark
                </span>
                {/* <CompanyInfo /> */}

                <div style={{ marginTop: '20px' }}>
                  <center>
                    <ContactUsForm />
                  </center>
                </div>
              </Col>
            </Row>
          </Container>

          {/* <Link to={`/packages`}>Packages</Link> */}
        </div>
      </div>
    );
  }
}
